import React, { Component, Fragment } from 'react'
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, { PATHS } from "../../../../constants/Define";
import Ripple from '../../common/component/Ripple';
import { Link } from 'react-router-dom';
import AgentList from './AgentList';
import { Button, Icon } from 'antd';
import { omit } from 'lodash';

let permisionActions = [];

class Agent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.agentState.pageSize,
                pageIndex: this.props.agentState.pageIndex,
            },
            loadingGroup: this.props.agentState.loadingGroup,
            saleOrderOpening: false
        }
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.AGENT);
        this.props.getListAgents(this.state.filters);
    }

    render() {
        const {t} = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, agents, loadingGroup } = this.props.agentState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};

        return (
            <Fragment>
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'agents'}
                        titleHeader={t('navigation.agents')}
                        componentRight={
                            <Fragment>
                                
                                {
                                    permisionActions && permisionActions.allowCreate &&
                                    <Button className="btn btn-primary ml-3">
                                        <Link to={PATHS.AGENT.CREATE.path} >+ Tạo mới</Link>
                                    </Button>
                                }
                            </Fragment>
                        }
                    />
                    <AgentList loading={isFetching}
                                  loadingGroup={loadingGroup}
                                  permisions={permisionActions}
                                  agents={agents}
                                  pagination={pagination}
                                  onChange={this.onTableChange}
                                  onDelete={this.onDeleteAgent}
                                  onDetailTableChange={this.onDetailTableChange}
                                  onItemExpanded={this.onItemExpanded}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onDetailTableChange = (agent, pagination, filters, sorter) => {
        let currentFilters = {agentId: agent.id, ...omit(agent.detail, ['items', 'orderBy', 'orderByDesc'])}
        filters = omit({ ...currentFilters, ...filters }, ['pageSize', 'pageIndex', 'totalCount', 'totalPage']);
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.props.getAgentListReports(newFilters);
    }

    onItemExpanded = (expanded, report) => {
        const filters = {agentId: report.id, ...omit(report.detail, ['items'])};
        this.props.getAgentListReports(filters);
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListAgents(newFilters);
    }

    onDeleteAgent = (item) => {
        this.props.deleteAgentDetail(item, {
            filters: {
                pageSize: this.props.agentState.pageSize,
                pageIndex: this.props.agentState.pageIndex
            }
        });
    }

}

export default Agent
